export const getCourseProgress = courseSlug => `/api/v1/member/courses/${courseSlug}`;
export const getCoursesEnrolled = () => `/api/v1/user/courses/enrolled`;
